export const WORK_ORDER_DOCUMENT_DROP_DOWN_ITEMS = []